import script from "./QRScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRScanner.vue?vue&type=script&setup=true&lang=ts"

import "./QRScanner.vue?vue&type=style&index=0&id=5b4dfe1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4dfe1c"]])

export default __exports__